const htmlBody = document.querySelector('#filmConsider_card').querySelector('div[name=remarksBody]');
import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';

import tools from '../tools/tools.js';
export default {

  cleanContainer() {
    htmlBody.innerHTML = '';
  },

  getElement(item, index , newMsg) {
    let msgsBody = '';

    let iRemoveBlock = '';
    let viewedStatus = '';

    if(item.details)
    {
      item.details.forEach((item, index) => {
        viewedStatus = '';
        if(item.viewed) {
          let viewedInt = parseInt(item.viewed, 10);
          if(viewedInt === 1)
            viewedStatus = 'Просмотрено через e-mail';
          else if(viewedInt === 2)
            viewedStatus = 'Просмотрено через смс';
          else if(viewedInt === 3)
            viewedStatus = 'Просмотрено в личном кабинете';

          if(item.timeViewed)
            viewedStatus = `${viewedStatus} - ${tools.dateStringFull(item.timeViewed)}`;
          else if (viewedInt === 1)
            viewedStatus = 'Просмотрено в личном кабинете';
        } 


        if(parseInt(auth.data.operatorId, 10) === parseInt(item.uid,10) && viewedStatus.length < 2)
          iRemoveBlock = ` <i class="ml-auto mr-3 mt-1" name="removeMsg" msgID="${item.mtoken}" >Удалить сообщение</i>`;
        else
          iRemoveBlock = ``;


        let nameClassMsg = 'msg_org';
        if(item.mail)
          nameClassMsg = 'msg_creator';

          msgsBody += `<div class = "${nameClassMsg}"> ${item.text}
                        <small class="row w-100 m-0 p-1 mt-1">
                        <i class="ml-1 mr-auto mt-1">${viewedStatus}</i>
                        <div class ="ml-auto mr-1 mt-1">    ${iRemoveBlock} ${(item.name) ? (`${item.name}  ` ) :''}  ${(item.phone && item.phone > 5) ? (item.phone) : ' '}  ${(item.mail) ? (item.mail) : ' '} </div>
                        <b class="ml-1 mr-1">${tools.dateStringFull(item.time)}</b>
                        </small>
                      </div>`;
      });
    }
    let user = '';
    let phone = '';

    if(item.details && item.details[0]){
      user = item.details[0].name;
      phone = item.details[0].phone;
    }

    let statusClass = 'blockHaveQuestion';
    let statusName = 'Ожидаем ответ от заявителя';
    let submitBT = `<button class="btn btn-cancel" type="button" name="cancelRemark" remarkID=${item.remarkID}>Отменить замечание</button>`;
    let chatHTML = `<div class="row m-0 p-0">
              <input type="text" class="w-80 ml-1 coommentAddInput" name="remark-${item.remarkID}-input">
              <button class="w-15 ml-auto mr-auto coommentAddBT btn " type="button" name="sendRemark" remarkID=${item.remarkID}>Отправить</button>
            </div>`;
    if (item.status == 2) {
      statusClass = 'blockWaitReview';
      statusName = 'Ответ от заявителя получен';
      submitBT = `<button class="btn btn-agree" type="button" name="agreeRemark" remarkID=${item.remarkID}>Принять изменения</button>
                  <button  type="button" class="btn btn-cancel" name="rejectRemark" remarkID=${item.remarkID}>Отклонить изменения</button>`;
    } else if (item.status == 3) {

      statusClass = 'blockReviewSuccess';
      statusName = 'Ответ от заявителя получен и принят.';
      submitBT = `<button class="btn btn-cancel" type="button" name="rejectRemark" remarkID=${item.remarkID}>Вернуться к обсуждению</button>`;
      chatHTML = '';
    }

    // проверка на доступ к редактированию =- 
    let arrPremissions = JSON.parse(auth.permissionsOnFest);
    
    //0 - блок спрятан
    //1 - ограниченное действие  - только просмотр
    //2 - полное взаимодействие
    if (parseInt(arrPremissions['cardTabChats'], 10) == 1) {
      submitBT = '';
      chatHTML = '';
    }

  return `<div class = "remarkCloud column ${newMsg ? 'little-icon-newMsg' :''}">
            <div class="row m-0 p-0 w-100 "> 
              <div class="column w-75 m-0 p-1">
                 <div class="row m-0 p-1 w-100"> 
                  <label class="mt-1">Статус:</label>  <b class="status ${statusClass}">${statusName}</b>
                </div>
                <div class="row m-0 p-0 w-100"> 
                  <label>Пользователь:</label> <b >${user} </b> <div class="ml-3">${phone}</div>
                </div>
                <div class="row m-0 p-0 w-100"> 
                  <label>Дата:</label><div class="mr-1">${tools.dateStringFull(item.time)}</div>
                </div>    
              </div>         
              <div class="w-25 m-0 p-0 submitBTS"> 
                ${submitBT}
              </div>

            </div>
             <div class="row m-0 p-1 w-100"> 
              <label>Блок:</label> <b>${item.block}</b>
              <label class="ml-auto mr-1">Выделенный текст:</label>
              <b class="m-0 p-0 mr-1">${(item.detail)?(item.detail):'-'}</b>
            </div>
            <h5 class="w-100 txt-al-center">Диалог с владельцем заявки по определенному замечанию:</h5>
            <div class="w-100 m-0 p-3 column">
              ${msgsBody}  
            </div>
            ${chatHTML}
          </div>`;
  },

  ifnull (someData) {
    return (someData)? someData : '';
  },

  drawDataInContainer(dataToDisplay, arrNotification) {

 
    this.cleanContainer();
    if(dataToDisplay){
      if(dataToDisplay.length== 0){
        htmlBody.innerHTML = '<button type="button" class="coommentAddBT btn addChat" name="createNewRemark">Создать замечание</button>';
      } else
       dataToDisplay.forEach((item, index) => {
        let newMsg = false;
        if(arrNotification)
          arrNotification.forEach((nItem, nIndex) => {
            if(item.remarkID === nItem.remarkID)
              newMsg = true;
          });
        htmlBody.insertAdjacentHTML('beforeend', this.getElement(item, index, newMsg));
       });
    }

  },

  drawMarkupInContainer(markup) {
    htmlBody.insertAdjacentHTML('beforeend', markup);
  },

};
